import {createBrowserHistory} from 'history';

// This history is created erroneously when View Invitation app loads
// so the '/event' path will prevent console errors from conflicting histories
const resolveBase = () => {
  const path = window.location.pathname;
  if (/^\/invitation-maker/.test(path)) return '/invitation-maker';
  if (/^\/invitation/.test(path)) return '/invitation';
  if (/^\/event/.test(path)) return '/event';
  return '';
};

export const history = createBrowserHistory({
  basename: resolveBase(),
});
